<h2
  style="font-weight: 600; line-height: 32px; color: #111827"
  mat-dialog-title
>
  <span style="font: bold">{{
    dialogData.additionalOutflow.outflowType || '-'
  }}</span>
  - <span class="h2__sin-file">Sin File</span>
</h2>

<mat-card-content
  *ngIf="isLoading"
  class="d-flex flex-col flex-wrap align-items-center justify-content-center"
  style="padding-bottom: 36px"
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <p>Cargando Egresos de Salida Adicional...</p>
</mat-card-content>

<mat-dialog-content
  class="row-base gap-30 div-center"
  style="height: fit-content; padding: 0px 30px"
>
  <div
    [style.display]="isLoading ? 'none' : 'flex'"
    class="row-base gap-30 div-center"
  >
    <form [formGroup]="newFoodItemForm" style="min-width: 100%">
      <div
        id="card-table-AS"
        class="column-base"
        [ngClass]="{
          active: displayForm,
          'gap-20': displayForm
        }"
      >
        <div class="row-base vertical-center title-AS-card-Cont">
          <div class="title-AS-card f-w-600 f-s-14">Añadir Insumos</div>
          <mat-icon
            style="cursor: pointer"
            (click)="setDisplayForm = !displayForm"
          >
            <i-tabler
              name="circle-chevron-up"
              class="icon-20 d-flex"
            ></i-tabler>
          </mat-icon>
        </div>
        <div *ngIf="displayForm" class="line"></div>
        <div
          class="insumoForm-cont"
          style="max-width: 100%; min-width: 100%; overflow-x: auto"
        >
          <div class="row-base" style="min-width: 100%">
            <div class="col-sm-4 w-100">
              <mat-label class="label">Insumo</mat-label>
              <mat-form-field
                appearance="outline"
                class="w-100 hide-hint"
                class="w-100 miBoton"
              >
                <input
                  matInput
                  type="text"
                  placeholder="Elige un Insumo"
                  formControlName="foodItem"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="getOptionText"
                  (optionSelected)="onFoodItemChanged($event)"
                >
                  <mat-option
                    *ngFor="let foodItem of foodItemsAutocomplete$ | async"
                    [value]="foodItem"
                  >
                    <span
                      style="
                        font-size: 12px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 100%;
                      "
                    >
                      STOCK: {{ foodItem.stock | number: '1.2-2' }}
                      {{ foodItem.unidadMedida }} -
                      <span style="font-weight: 500">{{
                        foodItem.nombreInsumo
                      }}</span>
                    </span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-sm-4 w-100">
              <mat-label class="label"> Cantidad Unitaria</mat-label>
              <mat-form-field
                appearance="outline"
                class="w-100 hide-hint"
                class="w-100 miBoton"
              >
                <input
                  matInput
                  placeholder="Cantidad"
                  formControlName="cantidad"
                  name="cantidad"
                  type="number"
                />
              </mat-form-field>
            </div>
            <div class="col-sm-4 w-100">
              <mat-label class="label">Unidad de Medida</mat-label>
              <mat-form-field
                appearance="outline"
                class="w-100 hide-hint"
                class="w-100 miBoton"
              >
                <input
                  matInput
                  placeholder="Unidad de Medida"
                  formControlName="unidadMedida"
                  name="unidad de medida"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>
          <div class="container-column gap-8">
            <mat-label class="label">Razón de salida</mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                placeholder="Descripción de la razón de salida"
                formControlName="observation"
                name="observation"
                rows="3"
                minlength="1"
                maxlength="500"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
              ></textarea>
              <mat-hint
                >{{
                  newFoodItemForm.get('observation')?.value?.length || 0
                }}/500</mat-hint
              >
            </mat-form-field>
          </div>
          <button
            mat-raised-button
            color="primary"
            style="
              width: fit-content;
              border-radius: 4px;
              box-shadow: none;
              font-size: 12px;
            "
            (click)="addFoodItemToAdditionalOutflow()"
            [disabled]="!newFoodItemForm.valid"
          >
            Confirmar Insumo
          </button>
        </div>
      </div>
    </form>

    <div
      style="
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
      "
    >
      <div
        style="
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        "
      >
        <div style="width: 100%; display: flex; align-items: center; gap: 24px">
          <span>OBSERVACIÓN:</span>
          <mat-form-field
            *ngIf="!isEditingAdditionalOutflowObservation"
            appearance="outline"
            class="w-100 hide-hint"
          >
            <input
              matInput
              [value]="dialogData.additionalOutflow.observation || '-'"
              readonly
              style="cursor: default"
            />
            <mat-icon
              matSuffix
              color="primary"
              style="cursor: pointer"
              (click)="enableAdditionalOutflowObservationEdit()"
              matTooltip="Editar observación"
            >
              <i-tabler name="pencil"></i-tabler>
            </mat-icon>
          </mat-form-field>

          <mat-form-field
            *ngIf="isEditingAdditionalOutflowObservation"
            style="width: 100%"
            appearance="outline"
          >
            <textarea
              matInput
              [(ngModel)]="additionalOutflowObservation"
              placeholder="Ingrese la observación de la salida"
              rows="3"
              minlength="1"
              maxlength="500"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"
            ></textarea>
            <mat-hint>{{ additionalOutflowObservation.length }}/500</mat-hint>
            <div matSuffix style="display: flex; gap: 8px; margin-left: 8px">
              <mat-icon
                style="cursor: pointer; color: #4caf50"
                (click)="saveAdditionalOutflowObservation()"
                title="Guardar cambios"
              >
                <i-tabler name="check" class="icon-20"></i-tabler>
              </mat-icon>
              <mat-icon
                style="cursor: pointer; color: #f44336"
                (click)="cancelAdditionalOutflowObservationEdit()"
                title="Cancelar cambios"
              >
                <i-tabler name="x" class="icon-20"></i-tabler>
              </mat-icon>
            </div>
          </mat-form-field>
          <div class="row-base gap-8">
            FECHA:
            {{ dialogData.additionalOutflow.createdAt | date: 'dd/MM/yyyy' }}
          </div>
        </div>
      </div>
      <div class="row-base gap-20" style="width: 100%">
        <div class="col-sm-4 w-100">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <mat-label>Categoría</mat-label>
            <mat-select
              [(value)]="selectedCategoria"
              (selectionChange)="applyFilterSelect()"
            >
              <mat-option [value]="null">Todas las categorías</mat-option>
              <mat-option
                *ngFor="let categoria of availableCategories"
                [value]="categoria"
              >
                {{ categoria }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 w-100">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <input
              matInput
              placeholder="Buscar..."
              (keyup)="applyFilter($event)"
            />
            <mat-icon matSuffix>
              <i-tabler name="search" class="icon-20"></i-tabler>
            </mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div style="width: 100%">
      <div class="table-responsive">
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          class="no-wrap m-t-0 v-middle w-100"
        >
          <ng-container matColumnDef="select">
            <th
              class="f-w-600 c-s-15 custom-column"
              mat-header-cell
              *matHeaderCellDef
            >
              <mat-checkbox
                color="primary"
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let row">
              <mat-checkbox
                color="primary"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="codigoInsumo">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Categoria
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
              {{
                element?.codigoInsumo ||
                  'Este Insumo ya no Existe en el Sistema'
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="nombre">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Nombre
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
              {{ element?.nombre }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cantidad">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Cantidad Retirada
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let foodItemOutflow; let i = index"
            >
              <div
                style="
                  display: flex;
                  gap: 10px;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div *ngIf="activeTextArea !== i" style="max-width: 80%">
                  {{ foodItemOutflow?.cantidad | number: '1.2-2' }}
                </div>
                <a
                  *ngIf="activeTextArea !== i"
                  (click)="
                    setActiveTextArea(i, foodItemOutflow);
                    $event.stopPropagation()
                  "
                  class="icon-Active"
                >
                  <i-tabler name="pencil" class="icon-20"></i-tabler>
                </a>

                <mat-form-field
                  appearance="outline"
                  class="w-100 hide-hint"
                  *ngIf="activeTextArea === i"
                  style="max-width: 120px"
                >
                  <input
                    (click)="$event.stopPropagation()"
                    [(ngModel)]="outflowQuantity"
                    matInput
                    min="0"
                    step="0.01"
                    type="number"
                  />
                </mat-form-field>

                <a
                  *ngIf="activeTextArea === i"
                  (click)="
                    updateOutflowQuantity(foodItemOutflow);
                    $event.stopPropagation()
                  "
                  class="icon-Active"
                >
                  <i-tabler name="check" class="icon-20"></i-tabler>
                </a>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="unidadMedida">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Unidad de Medida
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let outflow">
              {{ outflow?.unidadMedida || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="observation">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Observación
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let outflow">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 4px;
                  width: 100%;
                "
              >
                {{ outflow?.observation || '-' }}
                <div
                  (click)="openDialogEditObservation(outflow)"
                  class="icon-Active"
                  style="cursor: pointer"
                  [matTooltip]="'Editar Observación de Egreso'"
                >
                  <i-tabler name="pencil" class="icon-20"></i-tabler>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="evidencia">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              *matHeaderCellDef
            >
              Evidencia de Retiro
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let foodItemOutflow; let i = index"
            >
              <button
                mat-icon-button
                (click)="openDialogUploadEvidence(foodItemOutflow)"
              >
                <mat-icon
                  *ngIf="!foodItemOutflow.hasDocument"
                  [ngClass]="
                    foodItemOutflow.hasDocument ? 'icon-green' : 'icon-color'
                  "
                  [matTooltip]="'Subir evidencia de retiro'"
                >
                  upload
                </mat-icon>
                <mat-icon
                  *ngIf="foodItemOutflow.hasDocument"
                  [ngClass]="
                    foodItemOutflow.hasDocument ? 'icon-green' : 'icon-Active'
                  "
                  [matTooltip]="'Ver o descargar evidencia de retiro'"
                >
                  <i-tabler class="icon-20"> download </i-tabler>
                </mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="delete-outflow">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              *matHeaderCellDef
            >
              Eliminar
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let foodItemOutflow; let i = index"
            >
              <button
                mat-icon-button
                color="primary"
                (click)="deleteOutflow(foodItemOutflow)"
              >
                <mat-icon [matTooltip]="'Eliminar Egreso'">
                  <i-tabler name="trash">trash</i-tabler>
                </mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <div
        *ngIf="dataSource.filteredData.length === 0"
        class="div-center vertical-center"
        style="
          font-weight: 500;
          font-size: 12px;
          line-height: 14.4px;
          letter-spacing: 0%;
          color: #808080;
          min-height: 236px;
        "
      >
        Tu lista de insumos está vacía. ¡Agrega uno y aparecerá aquí!
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div
  class="column-base gap-20 div-center"
  style="padding: 30px; text-align: center; min-height: fit-content"
  *ngIf="!isLoading"
>
  <p>Seleccione los insumos que desea retirar y genere un PDF.</p>
  <p>
    Insumos seleccionados:<span style="color: var(--primary-color)">
      {{ selection.selected.length }}
    </span>
  </p>
  <div class="dialog-action-options row-base gap-20">
    <div class="dialog-action-option column-base gap-20 div-center">
      <div>Generar un PDF con los egresos.</div>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!selection.hasValue() || isLoadingGenerarPdf"
        style="
          width: fit-content;
          border-radius: 4px;
          box-shadow: none;
          font-size: 12px;
        "
        (click)="generarPDF()"
      >
        <div
          *ngIf="isLoadingGenerarPdf"
          style="width: 100%; cursor: not-allowed"
          class="row-base center-div vertical-center white-spinner gap-8"
        >
          Generando
          <mat-spinner [diameter]="20" class="white-spinner"></mat-spinner>
        </div>
        <span *ngIf="!isLoadingGenerarPdf">Generar PDF</span>
      </button>
    </div>
    <!-- <div class="dialog-action-option column-base gap-20 div-center">
      <div>Registrar los insumos en la tabla.</div>
      <button
        mat-raised-button
        class="buttonPrimary"
        style="
          width: fit-content;
          border-radius: 4px;
          box-shadow: none;
          font-size: 12px;
        "
        disabled
      >
        Insumo Añadido
      </button>
    </div> -->
  </div>
</div>
